/**
 * Returns the size in bytes of the given json data
 * stolen from
 *
 * https://hashnode.com/post/what-is-the-best-way-to-calculate-the-size-of-a-json-object-in-nodejs-cinklya0f00670d53c0puzb2u
 *
 */
export default function byteSize(data: any): number {
  return ~-encodeURI(JSON.stringify(data)).split(/%..|./).length;
}
